module.exports = __webpack_public_path__ + "img/delivery-1.94cf3b01.svg";